<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectedBillingStatus"
    style="min-width: 220px;"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Status FAT
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
import { JUDICIAL_STATUS, BILLING_STATUS } from '../../constants';

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedBillingStatus: this.value,
      options: [
        ...Object.entries(BILLING_STATUS).map(([statusKey, statusText]) => ({
          value: statusKey,
          text: statusText,
        })),

        ...Object.entries(JUDICIAL_STATUS).map(([statusKey, statusText]) => ({
          value: statusKey,
          text: statusText,
        })),

        { value: 'WAITING_GEN_INVOICE', text: 'Sem Fatura' },
      ],
    };
  },
  methods: {
    handleChange() {
      this.$emit('input', this.selectedBillingStatus);
    },
  },
};
</script>
